module.exports = __webpack_public_path__ + "static/media/goodnest_app9_preview.d9c23996.jpg";